export default function ContactSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-medium mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
            Fale Conosco
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Entre em Contato
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            Estamos prontos para ajudar você a encontrar a melhor solução
            financeira. Entre em contato pelos canais abaixo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <a
            href="https://wa.me/5511985860949"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-background-50 rounded-2xl p-8 border border-background-200 hover:border-primary-300 transition-all duration-300 hover:shadow-lg text-center"
          >
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
              <i className="ri-whatsapp-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
              WhatsApp
            </h3>
            <p className="text-foreground-600 text-sm">(11) 9.8586-0949</p>
            <p className="text-primary-600 text-sm font-medium mt-3 group-hover:text-primary-700 transition-colors">
              Iniciar conversa
            </p>
          </a>

          <a
            href="tel:+5511985860949"
            className="group bg-background-50 rounded-2xl p-8 border border-background-200 hover:border-primary-300 transition-all duration-300 hover:shadow-lg text-center"
          >
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
              <i className="ri-phone-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
              Telefone
            </h3>
            <p className="text-foreground-600 text-sm">(11) 9.8586-0949</p>
            <p className="text-primary-600 text-sm font-medium mt-3 group-hover:text-primary-700 transition-colors">
              Ligar agora
            </p>
          </a>

          <a
            href="mailto:contato@rcrednegocios.com.br"
            className="group bg-background-50 rounded-2xl p-8 border border-background-200 hover:border-primary-300 transition-all duration-300 hover:shadow-lg text-center"
          >
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
              <i className="ri-mail-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
              E-mail
            </h3>
            <p className="text-foreground-600 text-sm">
              contato@rcrednegocios.com.br
            </p>
            <p className="text-primary-600 text-sm font-medium mt-3 group-hover:text-primary-700 transition-colors">
              Enviar e-mail
            </p>
          </a>
        </div>

        <div className="flex items-center justify-center gap-4 mt-10">
          <a
            href="https://www.instagram.com/rcred.negocios/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-background-200 rounded-full text-foreground-700 hover:text-primary-600 hover:border-primary-300 transition-all text-sm font-medium"
          >
            <i className="ri-instagram-line text-lg"></i>
            @rcrednegocios
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=100084138971032"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-background-200 rounded-full text-foreground-700 hover:text-primary-600 hover:border-primary-300 transition-all text-sm font-medium"
          >
            <i className="ri-facebook-fill text-lg"></i>
            rcrednegocios
          </a>
        </div>
      </div>
    </section>
  );
}